module.exports = __webpack_public_path__ + "static/media/phone.bf79b0b4.svg";